import React from "react";
import NotFoundImg from "../../images/Notfound.svg";
import { Logo, Background } from "../index";
const Link = require("react-router-dom").Link;

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="mx-auto d-block mb-3">
        <Logo width={80} />
      </div>
      <div className="col-xl-4 text-center">
        <img className="img-fluid" src={NotFoundImg} width="240" alt="Page Not Found" />
        <h6>Unable to resolve the request</h6>
      </div>
      <div className="col-xl-6 mt-4">
        <p>Unfortunately the page you requested was not found. Some of the possible reasons could be:</p>
        <ul>
          <li>
            The page you were looking for might no longer exist. Please try the options below.</li>
          <li>
            There was a temporary problem. Please make sure you refresh/reload the page your were on before this one.</li>
        </ul>
        <Link to="/" className="pt-4 d-block text-center">
          Return to Home Page
        </Link>
      </div>
      <Background path1={true} path2={true} />
    </div>
  );
};
export default NotFound;
